/**
 * gets a string (word or sentence in camelCase or PascalCase) and returns the kebab-case version of it
 * @param str
 */
export const kebabize = (str: string): string =>
  str
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/\s+/g, '-')
    .toLowerCase();
